// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SettingSvg from '@rsuite/icon-font/lib/action/Setting';
var Setting = createSvgIcon({
  as: SettingSvg,
  ariaLabel: 'setting',
  category: 'action',
  displayName: 'Setting'
});
export default Setting;